export const EmailPattern = {
	value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
	message: 'Invalid email address',
};

/**
 * Utility to infer common email providers from an email address
 * and optionally open the corresponding webmail app.
 */
export type EmailProvider = {
	name: string;
	url: string;
};

const PROVIDER_MAP: Record<string, EmailProvider> = {
	'gmail.com': { name: 'Google', url: 'https://mail.google.com' },
	'googlemail.com': { name: 'Google', url: 'https://mail.google.com' },
	'outlook.com': { name: 'Outlook', url: 'https://outlook.live.com/mail' },
	'hotmail.com': { name: 'Outlook', url: 'https://outlook.live.com/mail' },
	'live.com': { name: 'Outlook', url: 'https://outlook.live.com/mail' },
	'msn.com': { name: 'Outlook', url: 'https://outlook.live.com/mail' },
	'office365.com': { name: 'Outlook', url: 'https://outlook.office.com/mail' },
	'yahoo.com': { name: 'Yahoo', url: 'https://mail.yahoo.com' },
	'ymail.com': { name: 'Yahoo', url: 'https://mail.yahoo.com' },
	'icloud.com': { name: 'iCloud', url: 'https://www.icloud.com/mail' },
	'me.com': { name: 'iCloud', url: 'https://www.icloud.com/mail' },
	'mac.com': { name: 'iCloud', url: 'https://www.icloud.com/mail' },
	'aol.com': { name: 'AOL', url: 'https://mail.aol.com' },
	'proton.me': { name: 'Proton', url: 'https://mail.proton.me' },
	'protonmail.com': { name: 'Proton', url: 'https://mail.proton.me' },
	'zoho.com': { name: 'Zoho', url: 'https://mail.zoho.com' },
	'yandex.com': { name: 'Yandex', url: 'https://mail.yandex.com' },
	'gmx.com': { name: 'GMX', url: 'https://navigator.gmx.net/mail' },
	'hey.com': { name: 'HEY', url: 'https://app.hey.com' },
};

export const inferEmailProvider = (email: string): EmailProvider | null => {
	const domain = email.split('@')[1]?.toLowerCase();
	if (!domain) return null;
	return PROVIDER_MAP[domain] ?? null;
};

export const openEmailProvider = (email: string) => {
	const provider = inferEmailProvider(email);
	if (provider) {
		window.open(provider.url, '_blank', 'noopener,noreferrer');
	}
	return provider;
};

/**
 * Validates if a string is a valid email address using the main EmailPattern
 */
export const isValidEmail = (email: string): boolean => {
	return EmailPattern.value.test(email.trim());
};
